import React, { Component } from "react";
import "./Shopping.css";
import { Button } from "react-bootstrap";
import FancyCheckbox from "../../MaterialComponents/Material-Checkbox/Checkbox";
import Paper from "@material-ui/core/Paper";
import SwipeableList from "../SwipeableList/SwipeableList";
import SwipeableListItem from "../SwipeableListItem/SwipeableListItem";
import displayDate from "../../../Utilities/displayDate";
import orderList from "../../../Utilities/orderList";
import categorizeList from "../../../Utilities/categorizeList";
import { store } from "../../../Store/store";
import ListFunctions from "../ListFunctions/ListFunctions";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

let langData = require("../../../Data/language.json");

export default class Shopping extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteAllDialog: false,
    };
  }

  componentDidMount() {
    let currentOrder = store.getState().firebase.listOrder;
    if (currentOrder !== "" && currentOrder !== undefined) {
      orderList(this.props.currentShopping, currentOrder, "shopping");
    }
  }

  componentWillUnmount() {
    categorizeList("all", "shopping");
  }

  handleDeleteAllOpen = () => {
    this.setState({ deleteAllDialog: true });
  };

  handleDeleteAllClose = (value) => {
    this.setState({ deleteAllDialog: false });

    if (value === "yes") {
      this.props.onRemoveAllShoppingItems();
    }
  };

  render() {
    let content = [];
    let filterValue = this.props.filter;
    const { currentShopping } = this.props;
    let checkStyle = { color: "grey" };

    this.addItemTolist = (key) => {
      let manualSymbol = null;
      let ean = currentShopping[key].EANcode.toString();
      if (ean.length === 10) {
        manualSymbol = (
          <img
            src={require("../../../Images/Icons/manualIcon.svg")}
            alt="manualIcon"
            style={{ marginLeft: "4px", width: "12px", height: "12px" }}
            className="manualIcon"
          ></img>
        );
      }

      var climateImg = null;
      if (currentShopping[key].carbon_fp !== undefined) {
        if (currentShopping[key].carbon_fp.climateScore !== undefined) {
          climateImg = (
            <img
              className="climateScore"
              src={require(`../../../Images/Icons/${
                "score" + currentShopping[key].carbon_fp.climateScore + ".svg"
              }`)}
              alt="climateScore"
            />
          );
        } else {
          climateImg = (
            <img
              className="climateScore"
              src={require("../../../Images/Icons/scoreNan.svg")}
              alt="climateScore"
            />
          );
        }
      } else {
        climateImg = (
          <img
            className="climateScore"
            src={require("../../../Images/Icons/scoreNan.svg")}
            alt="climateScore"
          />
        );
      }

      content.push(
        <SwipeableListItem
          key={currentShopping[key].EANcode}
          expanded={false}
          id={currentShopping[key].EANcode}
          onSwipe={(removeAll) =>
            this.props.onDelete(currentShopping[key], "shopping", removeAll)
          }
        >
          <div className="container col-5 listCell" style={checkStyle}>
            {climateImg}
            {currentShopping[key].name}
            {manualSymbol}
          </div>
          <div className="container col-1 listCell" style={checkStyle}>
            {currentShopping[key].quantity}
          </div>
          <div className="container col-2 listDate" style={checkStyle}>
            {displayDate(currentShopping[key].dates[0])}
          </div>
          <div
            className="container col-2 listCell d-none d-sm-block"
            style={checkStyle}
          >
            {currentShopping[key].comment}
          </div>
          <div className="container col-2 listBtn listCheckBox">
            <FancyCheckbox
              currentItem={currentShopping[key]}
              handleCheck={this.props.handleCheck}
            />{" "}
          </div>
        </SwipeableListItem>
      );
    };
    if (currentShopping !== undefined || currentShopping.length !== 0) {
      for (let key in currentShopping) {
        if (filterValue === "" || filterValue === undefined) {
          if (currentShopping[key].checked) {
            checkStyle = { color: "grey", textDecoration: "line-through" };
          } else checkStyle = { color: "#212529" };
          try {
            this.addItemTolist(key);
          } catch (error) {
            console.log(error);
          }
        } else {
          if (currentShopping[key].checked) {
            checkStyle = { color: "grey", textDecoration: "line-through" };
          } else checkStyle = { color: "#212529" };
          try {
            if (currentShopping[key].name.toLowerCase().includes(filterValue)) {
              this.addItemTolist(key);
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
    }

    return (
      <div className="row">
        <Paper
          className="container-fluid col-lg-10 col-md-10 col-sm-11 shoppingBody"
          elevation={6}
          square
        >
          <ListFunctions
            language={this.props.language}
            onSearch={this.props.onSearch}
            filter={this.props.filter}
            emptyFilter={this.props.emptyFilter}
          />
          <SwipeableList language={this.props.language}>
            {content}
          </SwipeableList>
          {currentShopping === null || currentShopping.length === 0 ? null : (
            <div className="container-fluid col-8 col-sm-4 deleteItemBtnWrapper">
              <Button
                className="deleteAllItemsBtn"
                variant="light"
                onClick={this.handleDeleteAllOpen}
              >
                {" "}
                <img
                  src={require("../../../Images/Icons/delete.svg")}
                  alt="shoppingIcon"
                ></img>{" "}
              </Button>
              <h6>{langData[this.props.language].shopping.deleteAll}</h6>
            </div>
          )}
          <Dialog
            onClose={() => this.handleDeleteAllClose("no")}
            aria-labelledby="dialogTitle"
            open={this.state.deleteAllDialog}
          >
            <DialogTitle
              style={{ textAlign: "center" }}
              id="simple-dialog-title"
            >
              {langData[this.props.language].dialogs.emptyShopping.emptyList}
            </DialogTitle>
            <hr />
            <div className="dialogBtnRow row">
              <div className="container-fluid col-6 dialogBtnContainer">
                <Button
                  className="dialogYesBtn"
                  onClick={() => this.handleDeleteAllClose("yes")}
                >
                  <img
                    src={require("../../../Images/Icons/yes.svg")}
                    alt="yesIcon"
                  ></img>
                </Button>
                <p className="dialogBtnHelperTxt">
                  {langData[this.props.language].dialogs.emptyShopping.yes}
                </p>
              </div>
              <div className="container-fluid col-6 dialogBtnContainer">
                <Button
                  className="dialogNoBtn"
                  onClick={() => this.handleDeleteAllClose("no")}
                >
                  <img
                    src={require("../../../Images/Icons/No.svg")}
                    alt="noIcon"
                  ></img>
                </Button>
                <p className="dialogBtnHelperTxt">
                  {langData[this.props.language].dialogs.emptyShopping.cancel}
                </p>
              </div>
            </div>
          </Dialog>
        </Paper>
      </div>
    );
  }
}
